

// import React, { useEffect, useRef, useState } from "react";
// import axios from "axios";
// import './dashboard.css';
// import { FaCheckCircle, FaExclamationCircle, FaBalanceScale, FaCoins } from "react-icons/fa";
// import {
//   LineChart,
//   Line,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   ResponsiveContainer,
// } from "recharts";
// import gsap from "gsap";
// import Piechart from "./piechart";

// function Dashboard() {
//   const [summary, setSummary] = useState({
//     paid_amount: 0,
//     pending_amount: 0,
//     failed_count: 0,
//   });
//   const cardRefs = useRef([]);

//   // Fetch transactions and compute summary
//   const fetchTransactions = async () => {
//     try {
//       const res = await axios.get("https://bodhimaram.onrender.com/paylinks");
//       const tx = res.data;

//       const paid_amount = tx
//         .filter(t => t.status.toLowerCase() === "paid")
//         .reduce((sum, t) => sum + parseFloat(t.amount), 0);

//       const pending_amount = tx
//         .filter(t => t.status.toLowerCase() === "pending")
//         .reduce((sum, t) => sum + parseFloat(t.amount), 0);

//       const failed_count = tx.filter(t => t.status.toLowerCase() === "failed").length;

//       setSummary({ paid_amount, pending_amount, failed_count });
//     } catch (err) {
//       console.error("Dashboard fetch error", err);
//     }
//   };

//   useEffect(() => {
//     fetchTransactions();
//   }, []);

//   useEffect(() => {
//     if (cardRefs.current.length > 0) {
//       gsap.fromTo(
//         cardRefs.current,
//         { opacity: 0, y: 40, scale: 0.95 },
//         { opacity: 1, y: 0, scale: 1, duration: 0.8, ease: "power3.out", stagger: 0.2 }
//       );
//     }
//   }, [summary]);

//   // Format numbers like 154000 → 1.54L, 42000 → 42K
//   const formatNumber = (num) => {
//     if (num >= 100000) return (num / 100000).toFixed(2) + "L";
//     if (num >= 1000) return (num / 1000).toFixed(2) + "K";
//     return num.toFixed(2);
//   };

//   const totalAmount = summary.paid_amount + summary.pending_amount;
//   const grandTotal = summary.paid_amount + summary.pending_amount + summary.failed_count;

//   // Dummy chart data (replace with dynamic if needed)
//   const data = [
//     { name: "Jan", collected: summary.paid_amount / 12, due: summary.pending_amount / 12 },
//     { name: "Feb", collected: summary.paid_amount / 12, due: summary.pending_amount / 12 },
//     { name: "Mar", collected: summary.paid_amount / 12, due: summary.pending_amount / 12 },
//     { name: "Apr", collected: summary.paid_amount / 12, due: summary.pending_amount / 12 },
//     { name: "May", collected: summary.paid_amount / 12, due: summary.pending_amount / 12 },
//     { name: "Jun", collected: summary.paid_amount / 12, due: summary.pending_amount / 12 },
//     { name: "Jul", collected: summary.paid_amount / 12, due: summary.pending_amount / 12 },
//   ];

//   return (
//     <div className="dashboard-container">
//       <div className="mains-content">
//         <div className="head">
//           <h2>Overview</h2>
//           <select>
//             <option>This Month</option>
//             <option>Last Month</option>
//             <option>This Year</option>
//             <option>Overall</option>
//           </select>
//         </div>

//         {/* Animated Cards */}
//         <div className="cards">
//           <div className="card" ref={el => (cardRefs.current[0] = el)}>
//             <div className="card-header">
//               <div className="icon green"><FaCheckCircle /></div>
//               <h3>₹{formatNumber(summary.paid_amount)}</h3>
//             </div>
//             <div className="progress-text">
//               <span>Collected</span>
//               <span className="trend up">
//                 {totalAmount ? `+${((summary.paid_amount / totalAmount) * 100).toFixed(1)}%` : "+0%"}
//               </span>
//             </div>
//           </div>

//           <div className="card" ref={el => (cardRefs.current[1] = el)}>
//             <div className="card-header">
//               <div className="icon red"><FaExclamationCircle /></div>
//               <h3>₹{formatNumber(summary.pending_amount)}</h3>
//             </div>
//             <div className="progress-text">
//               <span>Due</span>
//               <span className="trend down">
//                 {totalAmount ? `-${((summary.pending_amount / totalAmount) * 100).toFixed(1)}%` : "-0%"}
//               </span>
//             </div>
//           </div>

//           <div className="card" ref={el => (cardRefs.current[2] = el)}>
//             <div className="card-header">
//               <div className="icon yellow"><FaBalanceScale /></div>
//               <h3>{summary.failed_count}</h3>
//             </div>
//             <div className="progress-text">
//               <span>To be Settled</span>
//               <span className="trend neutral">0%</span>
//             </div>
//           </div>

//           {/* Grand Total Card */}
//           <div className="card" ref={el => (cardRefs.current[3] = el)}>
//             <div className="card-header">
//               <div className="icon blue"><FaCoins /></div>
//               <h3>₹{formatNumber(grandTotal)}</h3>
//             </div>
//             <div className="progress-text">
//               <span>Grand Total</span>
//               <span className="trend up">100%</span>
//             </div>
//           </div>
//         </div>

//         {/* Chart Section */}
//         <div className="chart-container">
//           <h3 style={{ color: "black" }}>Revenue</h3>
//           <ResponsiveContainer width="100%" height={300}>
//             <LineChart data={data}>
//               <CartesianGrid strokeDasharray="3 3" />
//               <XAxis dataKey="name" />
//               <YAxis />
//               <Tooltip />
//               <Line type="monotone" dataKey="collected" stroke="green" strokeWidth={2} />
//               <Line type="monotone" dataKey="due" stroke="orange" strokeWidth={2} />
//             </LineChart>
//           </ResponsiveContainer>  
//         </div>

//         <div className="chart-second">
//           <div>
//             <h1>Group Members</h1>
//           </div>
//           <div className="piechart-container">
//             <Piechart />
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default Dashboard;


import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import "./dashboard.css";
import {
  FaCheckCircle,
  FaExclamationCircle,
  FaBalanceScale,
  FaCoins,
  FaBars,
  FaBell,
  FaRegCalendarAlt,
  FaChevronRight,
  FaUserPlus,
  FaMoneyBillWave,
  FaCalendarCheck,
  FaChartBar,
  FaUserCircle,
} from "react-icons/fa";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import gsap from "gsap";
import Piechart from "./piechart.js";

function Dashboard() {
  const [summary, setSummary] = useState({
  paid_amount: 0,
  pending_amount: 0,
  failed_count: 0,
});

const [transactions, setTransactions] = useState([]);
const [chartData, setChartData] = useState([]);
  const cardRefs = useRef([]);

const fetchTransactions = async () => {
  try {
    const res = await axios.get(
      "https://bodhimaram.onrender.com/paylinks"
    );

    const tx = res.data || [];

    setTransactions(tx);

    const paid_amount = tx
      .filter(
        (t) => t.status?.toLowerCase() === "paid"
      )
      .reduce(
        (sum, t) => sum + Number(t.amount),
        0
      );

    const pending_amount = tx
      .filter(
        (t) =>
          t.status?.toLowerCase() ===
          "pending"
      )
      .reduce(
        (sum, t) => sum + Number(t.amount),
        0
      );

    const failed_count = tx.filter(
      (t) =>
        t.status?.toLowerCase() ===
        "failed"
    ).length;

    setSummary({
      paid_amount,
      pending_amount,
      failed_count,
    });

    /* Revenue Chart */

    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    const monthly = months.map((m) => ({
      name: m,
      collected: 0,
      due: 0,
    }));

    tx.forEach((t) => {
      if (!t.created_at) return;

      const d = new Date(t.created_at);

      const index = d.getMonth();

      if (
        t.status?.toLowerCase() ===
        "paid"
      ) {
        monthly[index].collected += Number(
          t.amount
        );
      }

      if (
        t.status?.toLowerCase() ===
        "pending"
      ) {
        monthly[index].due += Number(
          t.amount
        );
      }
    });

    setChartData(monthly);
  } catch (err) {
    console.log(err);
  }
};

useEffect(() => {
  fetchTransactions();
}, []);

  // 🔥 Card Animation
  useEffect(() => {
    if (cardRefs.current.length > 0) {
      gsap.fromTo(
        cardRefs.current,
        {
          opacity: 0,
          y: 40,
          scale: 0.95,
        },
        {
          opacity: 1,
          y: 0,
          scale: 1,
          duration: 0.8,
          ease: "power3.out",
          stagger: 0.2,
        }
      );
    }
  }, [summary]);

  // 🔥 Number Formatter
  const formatNumber = (num) => {
    if (num >= 100000) return (num / 100000).toFixed(2) + "L";
    if (num >= 1000) return (num / 1000).toFixed(2) + "K";
    return num.toFixed(2);
  };

  const totalAmount = summary.paid_amount + summary.pending_amount;

  const grandTotal =
    summary.paid_amount + summary.pending_amount + summary.failed_count;

  // 🔥 Chart Data
  const data = chartData;

  
 const recentTransactions = transactions
  .slice(0, 5)
  .map((t) => ({
    id: t.id,
    name: t.student_name,
    cls: t.class_name,
    amount: t.amount,
    status: t.status,
    date: new Date(
      t.created_at
    ).toLocaleDateString(),
  }));

// Greeting based on current time
const getGreeting = () => {
  const hour = new Date().getHours();

  if (hour >= 5 && hour < 12) {
    return {
      text: "Good Morning",
      emoji: "🌅",
    };
  }

  if (hour >= 12 && hour < 15) {
    return {
      text: "Good Afternoon",
      emoji: "☀️",
    };
  }

  if (hour >= 15 && hour < 19) {
    return {
      text: "Good Evening",
      emoji: "🌇",
    };
  }

  return {
    text: "Good Night",
    emoji: "🌙",
  };
};

const greeting = getGreeting();

  return (
    <div className="dashboard-container">
      {/* ============== MOBILE-ONLY HEADER (hidden on desktop) ============== */}
      <div className="mobile-topbar">
        
        <div className="mobile-greet">
        
          <span>
  {greeting.text}, {greeting.emoji}
</span>

          <h2>
  {JSON.parse(
    sessionStorage.getItem("user")
  )?.name || "Admin"}
</h2>
        </div>
        
      </div>

      <div className="mobile-filterbar">
        <div className="mobile-date-pill">
          <FaRegCalendarAlt />
         {new Date().toLocaleDateString("en-IN", {
  day: "numeric",
  month: "short",
  year: "numeric",
})}
        </div>
        
        <select className="mobile-month-select">
          <option>This Month</option>
          <option>Last Month</option>
          <option>This Year</option>
          <option>Overall</option>
        </select>
        
      </div>

      <div className="mains-content">
        <div className="head">
          <h2>Overview</h2>

          <select>
            <option>This Month</option>
            <option>Last Month</option>
            <option>This Year</option>
            <option>Overall</option>
          </select>
        </div>

        {/* SUMMARY CARDS (desktop unchanged) */}
        <div className="cards">
          {/* Collected */}
          <div className="card" ref={(el) => (cardRefs.current[0] = el)}>
            <div className="card-header">
              <div className="icon green">
                <FaCheckCircle />
              </div>

              <h3>₹{formatNumber(summary.paid_amount)}</h3>
            </div>

            <div className="progress-text">
              <span>Collected</span>

              <span className="trend up">
                {totalAmount
                  ? `+${(
                      (summary.paid_amount / totalAmount) *
                      100
                    ).toFixed(1)}%`
                  : "+0%"}
              </span>
            </div>
          </div>

          {/* Due */}
          <div className="card" ref={(el) => (cardRefs.current[1] = el)}>
            <div className="card-header">
              <div className="icon red">
                <FaExclamationCircle />
              </div>

              <h3>₹{formatNumber(summary.pending_amount)}</h3>
            </div>

            <div className="progress-text">
              <span>Due</span>

              <span className="trend down">
                {totalAmount
                  ? `-${(
                      (summary.pending_amount / totalAmount) *
                      100
                    ).toFixed(1)}%`
                  : "-0%"}
              </span>
            </div>
          </div>

          {/* Failed */}
          <div className="card" ref={(el) => (cardRefs.current[2] = el)}>
            <div className="card-header">
              <div className="icon yellow">
                <FaBalanceScale />
              </div>

              <h3>{summary.failed_count}</h3>
            </div>

            <div className="progress-text">
              <span>To be Settled</span>

              <span className="trend neutral">0%</span>
            </div>
          </div>

          {/* Grand Total */}
          <div className="card" ref={(el) => (cardRefs.current[3] = el)}>
            <div className="card-header">
              <div className="icon green">
                <FaCoins />
              </div>

              <h3>₹{formatNumber(grandTotal)}</h3>
            </div>

            <div className="progress-text">
              <span>Grand Total</span>

              {/* <span className="trend up">100%</span> */}
            </div>
          </div>
        </div>

        {/* ============== MOBILE-ONLY SUMMARY CARDS (image layout) ============== */}
        <div className="mobile-cards">
          <div className="m-card">
            <div className="m-card-top">
              <div className="m-icon m-icon-green">
                <FaCheckCircle />
              </div>
              <span className="m-label">Collected</span>
            </div>
            <h3 className="m-value">₹{formatNumber(summary.paid_amount)}</h3>
            <span className="m-trend up">
              ↑{" "}
              {totalAmount
                ? `${((summary.paid_amount / totalAmount) * 100).toFixed(
                    1
                  )}%`
                : "0%"}{" "}
              from last month
            </span>
          </div>

          <div className="m-card">
            <div className="m-card-top">
              <div className="m-icon m-icon-orange">
                <FaExclamationCircle />
              </div>
              <span className="m-label">Due Amount</span>
            </div>
            <h3 className="m-value">
              ₹{formatNumber(summary.pending_amount)}
            </h3>
            <span className="m-trend down">
              ↓{" "}
              {totalAmount
                ? `${((summary.pending_amount / totalAmount) * 100).toFixed(
                    1
                  )}%`
                : "0%"}{" "}
              from last month
            </span>
          </div>

          <div className="m-card">
            <div className="m-card-top">
              <div className="m-icon m-icon-red">
                <FaExclamationCircle />
              </div>
              <span className="m-label">Failed Transactions</span>
            </div>
            <h3 className="m-value">{summary.failed_count}</h3>
            {/* <span className="m-trend down">↓ 5.2% from last month</span> */}
          </div>

          <div className="m-card">
            <div className="m-card-top">
              <div className="m-icon m-icon-blue">
                <FaCoins />
              </div>
              <span className="m-label">Grand Total</span>
            </div>
            <h3 className="m-value">₹{formatNumber(grandTotal)}</h3>
            {/* <span className="m-trend up">↑ 10.3% from last month</span> */}
          </div>
        </div>

        {/* Chart Section (shared by desktop + mobile) */}
        <div className="chart-container">
          <div className="chart-title-row">
            <h3 style={{ color: "black" }}>Revenue</h3>
            <span className="mobile-view-details">
              View Details <FaChevronRight size={11} />
            </span>
          </div>

          <ResponsiveContainer width="100%" height={300}>
            <LineChart data={data}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Line
                type="monotone"
                dataKey="collected"
                stroke="#2563eb"
                strokeWidth={2}
              />
              <Line
                type="monotone"
                dataKey="due"
                stroke="orange"
                strokeWidth={2}
              />
            </LineChart>
          </ResponsiveContainer>
        </div>

        {/* ============== MOBILE-ONLY QUICK ACTIONS ============== */}
        <div className="mobile-quick-actions">
          <h3 className="mobile-section-title">Quick Actions</h3>
          <div className="quick-actions-grid">
            <button className="qa-btn qa-blue">
              <FaUserPlus />
              <span>Add Student</span>
            </button>
            <button className="qa-btn qa-green">
              <FaMoneyBillWave />
              <span>Collect Fees</span>
            </button>
            <button className="qa-btn qa-purple">
              <FaCalendarCheck />
              <span>Attendance</span>
            </button>
            <button className="qa-btn qa-orange">
              <FaChartBar />
              <span>Reports</span>
            </button>
          </div>
        </div>

        {/* ============== MOBILE-ONLY RECENT TRANSACTIONS ============== */}
        <div className="mobile-recent">
          <div className="mobile-section-row">
            <h3 className="mobile-section-title">Recent Transactions</h3>
            <span className="mobile-view-all">View All</span>
          </div>

          <div className="mobile-recent-list">
            {recentTransactions.map((t) => (
              <div className="mobile-recent-item" key={t.id}>
                <div className="mr-left">
                  <FaUserCircle className="mr-avatar" />
                  <div>
                    <p className="mr-name">{t.name}</p>
                    <span className="mr-class">{t.cls}</span>
                  </div>
                </div>

                <div className="mr-mid">
                  <span className="mr-amount">₹{t.amount}</span>
                  <span
                    className={`mr-status ${t.status.toLowerCase()}`}
                  >
                    {t.status}
                  </span>
                </div>

                <div className="mr-right">
                  <span className="mr-date">{t.date}</span>
                  <FaChevronRight size={12} />
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="chart-second">
          <div>
            <h1>Group Members</h1>
          </div>

          <div className="piechart-container">
            <Piechart />
          </div>
        </div>
      </div>

      {/* ============== MOBILE-ONLY BOTTOM NAV ============== */}
      <div className="mobile-bottom-nav">
        <div className="bn-item bn-active">
          <FaChartBar />
          <span>Dashboard</span>
        </div>
        <div className="bn-item">
          <FaUserPlus />
          <span>Students</span>
        </div>
        <div className="bn-item">
          <FaMoneyBillWave />
          <span>Fees</span>
        </div>
        <div className="bn-item">
          <FaChartBar />
          <span>Reports</span>
        </div>
        <div className="bn-item">
          <span className="bn-dots">•••</span>
          <span>More</span>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;